<template>
    <div class="ads-container-wrapper" @mousemove="this.customPointerPosition" :style="getBackgroundImageStyle()"
         @click="openLink()">
        <div class="ad-img-large" :style="getLargeImageStyle()"></div>
        <div class="ad-img-small" :style="getSmallImageStyle()"></div>
        <div class="custom-cursor" ref="customCursor">Mehr erfahren</div>
    </div>
</template>

<script>
import AdService from "../../services/AdService";

export default {
    name: "LoginAd",
    data: function () {
        return {
            activeImage: {}
        }
    },
    computed: {
        /**
         * Hardcoded fallback ads used when API is unavailable or feature flag is off
         * These will be removed in a future cleanup once the API is fully deployed
         */
        hardcodedImages: function () {
            if (this.$features.WHITELABEL) {
                return [
                    {
                        background: ``,
                        backgroundColor: "black",
                        desktop: this.$whitelabelConfig.loginImage,
                        mobile: this.$whitelabelConfig.loginImage,
                    }
                ]
            }
            return [
                {
                    background: ``,
                    backgroundColor: "#fff",
                    desktop: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-javascript-11-24-desktop`,
                    mobile: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-javascript-11-24-mobile`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-javascript-11-24-link",
                    target: "_blank"
                },
                {
                    background: ``,
                    backgroundColor: "#fff",
                    desktop: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-kotlin-11-24-desktop`,
                    mobile: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-kotlin-11-24-mobile`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-kotlin-11-24-link",
                    target: "_blank"
                },
                {
                    background: ``,
                    backgroundColor: "#fff",
                    desktop: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-php-11-24-desktop`,
                    mobile: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-php-11-24-mobile`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-php-11-24-link",
                    target: "_blank"
                },
                {
                    background: ``,
                    backgroundColor: "#fff",
                    desktop: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-python-11-24-desktop`,
                    mobile: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-python-11-24-mobile`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-python-11-24-link",
                    target: "_blank"
                },
            ];
        }
    },
    async created() {
        // If AD_PLACEMENT_MANAGEMENT feature flag is enabled, try to fetch from API
        if (this.$features.AD_PLACEMENT_MANAGEMENT) {
            try {
                const ads = await AdService.getAdPlacements('login');
                if (ads && ads.length > 0) {
                    // Use API ads - select a random one and normalize the format
                    this.activeImage = this.selectRandomAd(ads);
                    return;
                } else {
                    // API returned empty array, fall back to hardcoded
                    console.warn('No ads from API, falling back to hardcoded');
                }
            } catch (error) {
                // API error, fall back to hardcoded
                console.warn('Ad API failed, falling back to hardcoded:', error);
            }
        }
        
        // Fallback to hardcoded ads (when feature flag is off or API failed/returned empty)
        this.activeImage = this.getRandomHardcodedImage();
    },
    methods: {
        /**
         * Opens the ad link in a new tab or same window based on target setting
         * Note: Analytics tracking is handled automatically by the shortener app
         * when using API-provided URLs - no explicit tracking calls needed
         */
        openLink: function () {
            localStorage.setItem("promotion", this.activeImage.link);
            // Analytics tracking removed - shortener app handles it automatically via ShortenerLinkCall
            if (this.activeImage.target) {
                window.open(this.activeImage.link, this.activeImage.target);
                return;
            }
            window.location.href = this.activeImage.link;
        },
        /**
         * Selects a random ad from the provided array and normalizes the format
         * to work with both API responses and hardcoded ads
         * 
         * @param {Array} ads - Array of ad objects (either from API or hardcoded)
         * @returns {Object} - Normalized ad object with desktop, mobile, link, backgroundColor, target fields
         */
        selectRandomAd: function (ads) {
            const ad = ads[Math.floor(Math.random() * ads.length)];
            // Normalize field names to support both API format and hardcoded format
            return {
                desktop: ad.desktop_image_url || ad.desktop || '',
                mobile: ad.mobile_image_url || ad.mobile || '',
                link: ad.link_url || ad.link || '#',
                backgroundColor: ad.background_color || ad.backgroundColor || 'white',
                target: ad.target || '_blank',
                background: ad.background || ''
            };
        },
        /**
         * Gets a random image from the hardcoded fallback images
         */
        getRandomHardcodedImage: function () {
            return this.hardcodedImages[Math.floor(Math.random() * this.hardcodedImages.length)];
        },
        getBackgroundImageStyle: function () {
            return {
                "background-image": `url("${this.activeImage.background}")`,
                "background-color": this.$features.WHITELABEL ? 'white' : `${this.activeImage.backgroundColor}`,
                "pointer-events": this.$features.WHITELABEL ? "none" : "all",
            }
        },
        getLargeImageStyle: function () {
            return {
                "background-image": `url("${this.activeImage.desktop}")`
            }
        },
        getSmallImageStyle: function () {
            return {
                "background-image": `url("${this.activeImage.mobile}")`
            }
        },
        customPointerPosition: function (event) {
            const customCursor = this.$refs.customCursor;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            if (event.clientX + 25 + 175 >= windowWidth || event.clientY + 50 >= windowHeight) {
                customCursor.style.display = 'none';
            } else {
                customCursor.style.display = '';
            }
            customCursor.style.top = event.clientY - 5 + "px";
            customCursor.style.left = event.clientX + 25 + "px";

        }
    },
}
</script>

<style scoped>
.ads-container-wrapper {
    width: 100%;
    background-color: black;
    display: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: all linear 1s;
}

.ads-container-wrapper:hover > .ad-img-large, .ad-img-small {
    cursor: alias;
}

.ad-img-large, .ad-img-small {
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    display: none;
}

.ads-container-wrapper:hover > .custom-cursor {
    display: block;
}

.ads-container-wrapper:hover {
    background-image: none;
}

.ad-img-small {
    display: block;
}

.custom-cursor {
    position: absolute;
    text-transform: uppercase;
    text-shadow: 1px 1px 2px black;
    display: none;
    font-style: italic;
    font-size: 20px;
    font-weight: bold;
    color: whitesmoke;
}

@media (min-width: 500px) {
    .ads-container-wrapper {
        display: block;
    }
}

@media (min-width: 1380px) {
    .ad-img-small {
        display: none;
    }

    .ad-img-large {
        display: block;
    }
}

</style>
